import React from "react"
import { batch, useSignal } from '@preact/signals-react'

import { AppButtonIcon, AppOfficesBlock, AppToggleButton } from '@components'
import { AGGREGATION_PRICE } from "../../@constants"
import { BIAggregationPrice, BIFilters, BIIsLoadingChart, BIIsLoadingTable, BISelectedOffice, BISelectedOfficeOptions, BIShowByPrice } from '../../@signals'
import { Box } from "@mui/material"
import { AutocompleteSeeker } from '@ui-seeker/core'
import { isLoadingCommonFilters } from '../../../../../../@signals'
import { isEmpty, postExcel } from '@ui-seeker/utils'


const TABS = [
	{ label: 'Min. Price', value: AGGREGATION_PRICE.MIN },
	{ label: 'Avg. Price', value: AGGREGATION_PRICE.AVG },
	{ label: 'Max. Price', value: AGGREGATION_PRICE.MAX },
]

export default function BITableActions({ ...props }) {

	const isLoading = useSignal(false)
	if(isEmpty(BIFilters.value)) return null

	const handleButtonClick = (_, newValue) => batch(() => {
		BIIsLoadingChart.value = true
		BIIsLoadingTable.value = true
		setTimeout(() => {
			BIIsLoadingTable.value = false
			BIIsLoadingChart.value = false
		}, 100)
		BIAggregationPrice.value = newValue != null ? newValue : AGGREGATION_PRICE.MIN
		BIShowByPrice.value = newValue != null ? newValue : AGGREGATION_PRICE.MIN
	})


	return <Box sx={{ gap: 1, display: 'flex', alignItems: 'center', justifyContent: 'end' }}>
		<AppToggleButton
			tabs={TABS}
			value={BIAggregationPrice.value}
			onChange={handleButtonClick}
			buttonProps={{
				sx: { px: 2.5, py: 1, width: 100 }
			}}
			{...props}
		/>
		{!!BISelectedOfficeOptions.value?.length && <>
			<AutocompleteSeeker
				formatOptionLabel={({ label, office_type, country }) => <AppOfficesBlock name={label} type={office_type} country={country}/>}
				options={BISelectedOfficeOptions.value}
				onChange={e => {
					BISelectedOffice.value = e.target.value
					isLoadingCommonFilters.value = true
				}}
				label="Filter by specific office"
				placeholder="Leave on blank for no filtering"
				value={BISelectedOffice.value}
			/>
			<AppButtonIcon
				icon="file-zipper"
				onClick={() => {
					isLoading.value = true
					postExcel('/api/dashboard/excel-all-offices', BIFilters.value)
					.then(() => {
						isLoading.value = false
					})
				}}
				iconWeight="solid"
				tooltip="Download all offices excel"
				disabled={isLoading.value}

			/>
		</>}
	</Box>
}